// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2dMZh","header":"styles_header__2-5VY","blink":"styles_blink__De9Tx"};